import React from "react";
import { HotelHubProvider } from "./HotelHubProvider";
import { useHotel } from "../../contexts/HotelContext";

interface HotelHubWithHotelProviderProps {
  children: React.ReactNode;
}

export const HotelHubWithHotelProvider: React.FC<
  HotelHubWithHotelProviderProps
> = ({ children }) => {
  const { myHotelInfo } = useHotel();
  const hotelId = myHotelInfo?.hotelId;

  return (
    <HotelHubProvider hotelId={hotelId}>
      {children}
    </HotelHubProvider>
  );
};
